import { decimalToPercentage } from "@intentsify/utils";
import { useQuery } from "@tanstack/react-query";
import { StatCardsContainer } from "components";
import { getQuantumDemandDomainActivation } from "../../QuantumDemand.requests";

const DISPLAY_NO_DATA_MESSAGE =
  "No display campaign is mapped to this intent model.";
const OPT_INS_NO_DATA_MESSAGE =
  "No Convertr campaign is mapped to this intent model.";

interface AccountLevelActivationProps {
  campaignId: number;
  domain: string;
}

export const AccountLevelActivation = ({
  campaignId,
  domain,
}: AccountLevelActivationProps) => {
  const { data, isFetching } = useQuery(
    ["quantumDemandDomainActivation", campaignId, domain],
    () => getQuantumDemandDomainActivation(campaignId, domain),
  );

  const hasDisplayData = data?.adImpressions !== null;
  const hasOptInsData = data?.optIns !== null;

  return (
    <StatCardsContainer
      mb={0}
      items={[
        {
          isLoading: isFetching,
          title: "Ad Impressions",
          value: data?.adImpressions,
          noValueMessage: "0",
          hasData: hasDisplayData,
          noDataMessage: DISPLAY_NO_DATA_MESSAGE,
        },
        {
          isLoading: isFetching,
          title: "Ad Clicks",
          value: data?.adClicks,
          noValueMessage: "0",
          hasData: hasDisplayData,
          noDataMessage: DISPLAY_NO_DATA_MESSAGE,
        },
        {
          isLoading: isFetching,
          title: "CTR",
          value: data?.ctr,
          valueFormatter: (value) => `${decimalToPercentage(value)}%`,
          noValueMessage: "0%",
          hasData: hasDisplayData,
          noDataMessage: DISPLAY_NO_DATA_MESSAGE,
        },
        {
          isLoading: isFetching,
          title: "Opt-Ins",
          titleTooltip: "Billable leads delivered through Convertr.",
          value: data?.optIns,
          noValueMessage: "0",
          hasData: hasOptInsData,
          noDataMessage: OPT_INS_NO_DATA_MESSAGE,
        },
      ]}
    />
  );
};
